import Vue from 'vue'
import Vuex from 'vuex'
import campaigns from './Modules/campaigns.js'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    campaigns
  }
})
